export const AdviceBannerContent = {
  title: `Need help deciding what's next?`,
  description: `We understand this is a difficult time and are here to help you plan, provide support, and be your guide at every stage of your life.`,
  linkText: `Explore your advice options`,
  link: `https://investor.vanguard.com/advice/compare-investment-advice`,
};
